import React from 'react';
import {
  f7,
  Page,
  Navbar,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Preloader,
  TextEditor,
  Radio,
  Checkbox,
  Popover,
} from 'framework7-react';

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  WalletSvg,
} from '../components/crumbs';
import moment from 'moment';

// Redux
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withFirestore, firestoreConnect } from '../HOCs';
import {
  toast,
  handleErrors,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
} from '../utils/_helpers';
import {
  Collections,
  FilterByText,
  FilterByNumber,
  FilterBySelect,
} from '../utils/_classes';

class AdminUsers extends React.Component {
  constructor() {
    super();

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: '',
        which: '',
      },

      // sales single order detail
      salesOrderDetails: null,

      // notification data
      sendTo: ['All'],
      recipients: ['users'],
      notificationTitle: '',
      notificationBody: '',

      // state for form fields reset
      userFullName: '',
      userEmail: '',
      userPhoneNumber: '',
      userRole: 'All',

      // state for search fields reset [vendors]
      vendorName: '',
      vendorEmail: '',
      vendorType: '',

      // Data state
      users: [],

      // Vendors state
      vendors: [],

      filterBy: {
        dbName: '',
        property: '',
        value: '',
        type: '',
      },
    };
  }

  render() {
    return (
      <Page>
        <Block>
          <Card
            className="data-table data-table-init"
            style={{
              width: '100%',
              marginLeft: '0px',
              marginBottom: '80px',
              // maxHeight: '700px',
            }}>
            <CardHeader>
              <div className="data-table-title">All Users</div>
              <div className="data-table-actions">
                <Button
                  outline
                  iconF7="bell"
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      popupOpened: true,
                      popupDataChanged: true,
                      popupData: {
                        title: 'Send Notification',
                        which: 'notification',
                      },
                    });
                  }}>
                  &nbsp;&nbsp;&nbsp;Send Notification
                </Button>
              </div>
            </CardHeader>
            <CardContent
              padding={false}
              style={{
                width: '100%',
                // maxHeight: '600px',
                maxHeight:
                  parseInt(window.innerWidth) <= 1400 ? '70vh' : '80vh',
                paddingBottom: '20px',
                overflow: 'scroll',
              }}>
              <table className="sticky">
                <thead>
                  <tr>
                    <th>
                      <span className="table-head-label">SNo.</span>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Full name</span>
                      <div className="input">
                        <input
                          type="text"
                          value={this.state.userFullName}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              userFullName: e.target.value,
                              userEmail: '',
                              userPhoneNumber: '',
                              userRole: 'All',
                              filterBy: {
                                dbName: 'users',
                                property: 'fullName',
                                value: e.target.value,
                                type: 'text',
                              },
                            })
                          }
                          placeholder="Filter"
                        />
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Email</span>
                      <div className="input">
                        <input
                          type="email"
                          value={this.state.userEmail}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              userFullName: '',
                              userEmail: e.target.value,
                              userPhoneNumber: '',
                              userRole: 'All',
                              filterBy: {
                                dbName: 'users',
                                property: 'email',
                                value: e.target.value,
                                type: 'text',
                              },
                            })
                          }
                          placeholder="Filter"
                        />
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Phone</span>
                      <div className="input">
                        <input
                          type="number"
                          value={this.state.userPhoneNumber}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              userFullName: '',
                              userEmail: '',
                              userPhoneNumber: e.target.value,
                              userRole: 'All',
                              filterBy: {
                                dbName: 'users',
                                property: 'phoneNumber',
                                value: e.target.value,
                                type: 'number',
                              },
                            })
                          }
                          placeholder="Filter"
                        />
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Role</span>
                      <div className="input input-dropdown">
                        <select
                          value={this.state.userRole}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              userFullName: '',
                              userEmail: '',
                              userPhoneNumber: '',
                              userRole: e.target.value,
                              filterBy: {
                                dbName: 'users',
                                property: 'role',
                                value: e.target.value,
                                type: 'select',
                              },
                            })
                          }>
                          <option value="All">All</option>
                          <option value="Admin">Admin</option>
                          <option value="Basic">Basic</option>
                          <option value="Support">Support</option>
                        </select>
                      </div>
                    </th>
                    <th>
                      <span className="table-head-label">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.users.map(
                    (
                      {
                        fullName,
                        email,
                        phoneNumber,
                        role,
                        accountStatus,
                        id,
                        assignedVendors,
                        walletId,
                      },
                      i
                    ) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          <div>{fullName}</div>
                        </td>
                        <td>{email}</td>
                        <td>{phoneNumber}</td>
                        <td>{role}</td>
                        <td>
                          <Button
                            fill
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                popupOpened: true,
                                popupDataChanged: true,
                                popupData: {
                                  title: 'User Profile',
                                  which: 'profile',
                                  data: {
                                    fullName,
                                    email,
                                    phoneNumber,
                                    role,
                                    accountStatus,
                                    id,
                                    assignedVendors,
                                    walletId,
                                  },
                                },
                              });
                            }}>
                            View Profile
                          </Button>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </Block>

        <Popup 
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: '', which: '' },
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}>
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for message board notification */}
            {this.state.popupData.which == 'notification' ? (
              <Block>
                <Card style={{ margin: 'auto' }}>
                  <CardHeader className="no-border">
                    <div className="data-table-title">
                      Notification Recipients
                    </div>
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        title="To:"
                        after={this.state.sendTo.join(',')}
                        popoverOpen=".popover-recipients"
                        link="#"
                      />
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: '20pt auto' }}>
                  <CardHeader className="no-border">
                    <div className="data-table-title">Notification Editor</div>
                  </CardHeader>

                  <CardContent className="no-padding">
                    <List
                      style={{
                        margin: '0px',
                      }}>
                      <ListInput
                        label="Notification Title"
                        type="text"
                        value={this.state.notificationTitle}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            notificationTitle: e.target.value,
                          })
                        }
                        placeholder="Please enter title of notification here"></ListInput>
                    </List>

                    <TextEditor
                      style={{
                        marginTop: '20pt',
                        height: '300px',
                      }}
                      placeholder="Please enter the notification text..."
                      value={this.state.notificationBody}
                      onTextEditorChange={(value) =>
                        this.setState({
                          ...this.state,
                          notificationBody: value,
                        })
                      }
                      buttons={[
                        ['bold', 'italic', 'underline', 'strikeThrough'],
                        ['orderedList', 'unorderedList'],
                      ]}
                    />
                  </CardContent>

                  <CardFooter>
                    {/* Todo: disable button if no receipient is checked */}
                    <Button
                      round
                      fill
                      style={{ width: '100%' }}
                      onClick={this.sendNotification.bind(this)}>
                      Send Notification
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for viewing user profile */}
            {this.state.popupData.which == 'profile' ? (
              <Block>
                <Card style={{ margin: 'auto' }}>
                  <CardHeader>
                    {this.state.popupData.data.fullName}

                    <Button
                      outline
                      iconF7="doc_on_clipboard"
                      onClick={(e) =>
                        this.$f7.methods.copyText(e, 'Wallet Id')
                      }>
                      &nbsp;&nbsp;&nbsp;Wallet Id:
                      <span className="copytext">
                        {this.state.popupData.data.walletId}
                      </span>
                    </Button>
                  </CardHeader>

                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.data.fullName}
                        after="User Name">
                        <Icon f7="person" slot="media" />
                      </ListItem>

                      <ListItem
                        className="show-text"
                        title={this.state.popupData.data.email}
                        after="User Email">
                        <Icon f7="envelope" slot="media" />
                      </ListItem>

                      <ListItem
                        title={this.state.popupData.data.phoneNumber}
                        after="User Phone">
                        <Icon f7="phone" slot="media" />
                      </ListItem>

                      <ListItem
                        title={this.state.popupData.data.role}
                        after="User Role">
                        <Icon f7="circle_grid_hex" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      fill
                      style={{ width: '45%' }}
                      href={`mailto://${this.state.popupData.data.email}`}
                      external
                      onClick={() =>
                        this.$f7.methods.sendEmail(
                          this.state.popupData.data.email
                        )
                      }>
                      Email {this.state.popupData.data.fullName.split(' ')[0]}
                    </Button>

                    <Button
                      fill
                      style={{ width: '45%' }}
                      href={`tel://${this.state.popupData.data.phoneNumber}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.data.phoneNumber
                        )
                      }>
                      Call {this.state.popupData.data.fullName.split(' ')[0]}
                    </Button>
                  </CardFooter>
                </Card>

                {this.props.auth.uid !== this.state.popupData.data.id ? (
                  <Card style={{ margin: '10pt auto' }}>
                    <CardHeader>Change User Role</CardHeader>

                    <CardContent>
                      <List>
                        <ListItem
                          radio
                          radioIcon="end"
                          title="Admin Privilege"
                          checked={
                            this.props.ordered.users.find(
                              (user) => user.id === this.state.popupData.data.id
                            ).role === 'Admin'
                          }
                          value="Admin"
                          name="user-role"
                          onChange={(e) =>
                            this.changeUserRole(
                              this.state.popupData.data.id,
                              'Admin',
                              this.state.popupData.data.fullName
                            )
                          }></ListItem>
                        <ListItem
                          radio
                          radioIcon="end"
                          title="Basic User"
                          checked={
                            this.props.ordered.users.find(
                              (user) => user.id === this.state.popupData.data.id
                            ).role === 'Basic'
                          }
                          value="Basic"
                          name="user-role"
                          onChange={(e) =>
                            this.changeUserRole(
                              this.state.popupData.data.id,
                              'Basic',
                              this.state.popupData.data.fullName
                            )
                          }></ListItem>
                        <ListItem
                          radio
                          radioIcon="end"
                          title="Support Privilege"
                          checked={
                            this.props.ordered.users.find(
                              (user) => user.id === this.state.popupData.data.id
                            ).role === 'Support'
                          }
                          value="Support"
                          name="user-role"
                          onChange={(e) =>
                            this.changeUserRole(
                              this.state.popupData.data.id,
                              'Support',
                              this.state.popupData.data.fullName
                            )
                          }></ListItem>
                      </List>
                    </CardContent>

                    <CardFooter>
                      {this.props.ordered.users.find(
                        (user) => user.id === this.state.popupData.data.id
                      ).role === 'Support' &&
                      this.props.ordered.users.find(
                        (user) => user.id === this.state.popupData.data.id
                      ).accountStatus === 'Approved' ? (
                        <Button
                          fill
                          style={{ width: '45%' }}
                          onClick={(e) =>
                            // open vendor card
                            this.supportVendor()
                          }>
                          Assign Vendors
                        </Button>
                      ) : (
                        <span>&nbsp;</span>
                      )}
                      {this.props.ordered.users.find(
                        (user) => user.id === this.state.popupData.data.id
                      ).accountStatus === 'Approved' ? (
                        <Button
                          fill
                          className="button-fill-red"
                          style={{ width: '45%' }}
                          onClick={(e) =>
                            this.actionAgainstUser(
                              'suspend',
                              this.state.popupData.data.id,
                              this.state.popupData.data.role
                            )
                          }>
                          Suspend{' '}
                          {this.state.popupData.data.fullName.split(' ')[0]}
                        </Button>
                      ) : (
                        <Button
                          fill
                          className="button-fill-green"
                          style={{ width: '45%' }}
                          onClick={(e) =>
                            this.actionAgainstUser(
                              'release',
                              this.state.popupData.data.id
                            )
                          }>
                          Release Account
                        </Button>
                      )}
                    </CardFooter>
                  </Card>
                ) : null}

                {/* [Card - ] Assign vendors to support staff */}
                {/* Note:  Show vendors assigned to this staff here and also show vendors yet to be assigned as well */}
                {/* Note:  If the user role is no longer support unassign every vendor from the staff */}
                {this.props.ordered.users.find(
                  (user) => user.id === this.state.popupData.data.id
                ).role === 'Support' &&
                this.props.ordered.users.find(
                  (user) => user.id === this.state.popupData.data.id
                ).accountStatus === 'Approved' ? (
                  <Card
                    id="support-vendor"
                    className="data-table data-table-init"
                    style={{
                      margin: '10pt auto',
                      marginBottom: '80px',
                      maxHeight: '400px',
                      display: 'none',
                      animation: 'glow 2s ease 0s 1',
                    }}>
                    <CardHeader className="no-border">
                      <div className="data-table-title">
                        Assign Vendors [{this.state.popupData.data.fullName}]
                      </div>

                      <Button
                        onClick={() => {
                          this.$f7.$('#support-vendor').hide();
                          this.setState({
                            ...this.state,
                            vendorName: '',
                            vendorEmail: '',
                            vendorType: 'All',
                            filterBy: {
                              dbName: '',
                              property: '',
                              value: '',
                              type: '',
                            },
                          });
                        }}>
                        Close
                      </Button>
                    </CardHeader>
                    <CardContent
                      padding={false}
                      style={{
                        width: '100%',
                        maxHeight: '330px',
                        overflow: 'scroll',
                      }}>
                      <table className="sticky">
                        <thead>
                          <tr>
                            <th className="checkbox-cell">[Un]-Assign</th>
                            <th className="input-cell">
                              <span className="table-head-label">
                                Vendor Name
                              </span>
                              <div className="input">
                                <input
                                  type="text"
                                  value={this.state.vendorName}
                                  onChange={(e) =>
                                    this.setState({
                                      ...this.state,
                                      vendorName: e.target.value,
                                      vendorEmail: '',
                                      vendorType: 'All',
                                      filterBy: {
                                        dbName: 'vendors',
                                        property: 'name',
                                        value: e.target.value,
                                        type: 'text',
                                      },
                                    })
                                  }
                                  placeholder="Filter"
                                />
                              </div>
                            </th>
                            <th className="input-cell">
                              <span className="table-head-label">
                                Vendor Email
                              </span>
                              <div className="input">
                                <input
                                  type="email"
                                  value={this.state.vendorEmail}
                                  onChange={(e) =>
                                    this.setState({
                                      ...this.state,
                                      vendorName: '',
                                      vendorEmail: e.target.value,
                                      vendorType: 'All',
                                      filterBy: {
                                        dbName: 'vendors',
                                        property: 'email',
                                        value: e.target.value,
                                        type: 'text',
                                      },
                                    })
                                  }
                                  placeholder="Filter"
                                />
                              </div>
                            </th>
                            <th className="input-cell">
                              <span className="table-head-label">
                                Vendor Type
                              </span>
                              <div className="input input-dropdown">
                                <select
                                  value={this.state.vendorType}
                                  onChange={(e) =>
                                    this.setState({
                                      ...this.state,
                                      vendorName: '',
                                      vendorEmail: '',
                                      vendorType: e.target.value,
                                      filterBy: {
                                        dbName: 'vendors',
                                        property: 'type',
                                        value: e.target.value,
                                        type: 'select',
                                      },
                                    })
                                  }>
                                  <option value="All">All</option>
                                  <option value="fleetNumber">Delivery</option>
                                  <option value="ownsDelivery">Merchant</option>
                                </select>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.vendors
                            .filter((vendor) => {
                              let vendorType = vendor.businessProfile.hasOwnProperty(
                                'ownsDelivery'
                              )
                                ? 'Merchant'
                                : 'Delivery';

                              if (
                                this.props.data.users[
                                  this.state.popupData.data.id
                                ].assignedVendors &&
                                this.props.data.users[
                                  this.state.popupData.data.id
                                ].assignedVendors.length > 0 &&
                                this.props.data.users[
                                  this.state.popupData.data.id
                                ].assignedVendors.find(
                                  (v) =>
                                    v.id === vendor.id && v.type === vendorType
                                )
                              ) {
                                return true;
                              } else if (
                                this.props.ordered.users
                                  .filter(
                                    (user) =>
                                      user.role === 'Support' &&
                                      user.id !== this.state.popupData.data.id
                                  )
                                  .find(
                                    (user) =>
                                      user.assignedVendors &&
                                      user.assignedVendors.length > 0 &&
                                      user.assignedVendors.find(
                                        (uv) =>
                                          uv.id === vendor.id &&
                                          uv.type === vendorType
                                      )
                                  )
                              ) {
                                return false;
                              } else {
                                return true;
                              }
                            })
                            .map((v, i) => {
                              return (
                                <tr key={i}>
                                  <td className="checkbox-cell">
                                    <Checkbox
                                      onChange={(e) =>
                                        this.assignOrRemoveVendor(
                                          e,
                                          v,
                                          this.props.ordered.users.find(
                                            (uv) =>
                                              uv.id ===
                                              this.state.popupData.data.id
                                          )
                                        )
                                      }
                                      checked={
                                        this.props.data.users[
                                          this.state.popupData.data.id
                                        ].assignedVendors &&
                                        this.props.data.users[
                                          this.state.popupData.data.id
                                        ].assignedVendors.find(
                                          ({ id, type }) => {
                                            let vendorType = v.businessProfile.hasOwnProperty(
                                              'ownsDelivery'
                                            )
                                              ? 'Merchant'
                                              : 'Delivery';
                                            if (
                                              id === v.id &&
                                              type === vendorType
                                            ) {
                                              return true;
                                            } else {
                                              return false;
                                            }
                                          }
                                        )
                                          ? true
                                          : false
                                      }
                                    />
                                  </td>
                                  <td>
                                    <div>{v.businessProfile.name}</div>
                                  </td>
                                  <td>
                                    <div>{v.businessProfile.email}</div>
                                  </td>
                                  <td>
                                    <div>
                                      {v.businessProfile.ownsDelivery
                                        ? 'Merchant'
                                        : 'Delivery'}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                ) : null}
              </Block>
            ) : null}
          </Page>
        </Popup>

        <Popover className="popover-recipients">
          <List mediaList>
            {[
              { name: 'All', value: 'users' },
              { name: 'Delivery Agents', value: 'delivery' },
              { name: 'Easychaw Agents', value: 'partners' },
              { name: 'Merchants', value: 'merchants' },
            ].map((r, i) => (
              <ListItem onClick={() => this.selectRecipient(r)} key={i}>
                <Checkbox
                  slot="media"
                  checked={
                    this.state.recipients.indexOf(r.value) !== -1 ? true : false
                  }
                />
                {r.name}
              </ListItem>
            ))}
          </List>
        </Popover>
      </Page>
    );
  }

  //   Lifecycle
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.filterBy.dbName.trim() === '') {
      return {
        users: (nextProps.ordered && nextProps.ordered.users) || [],
        vendors:
          (nextProps.ordered &&
            nextProps.ordered.merchants &&
            nextProps.ordered.delivery && [
              ...nextProps.ordered.merchants,
              ...nextProps.ordered.delivery,
            ]) ||
          [],
      };
    } else {
      let modifiedState = {
        users: (nextProps.ordered && nextProps.ordered.users) || [],
        vendors:
          (nextProps.ordered &&
            nextProps.ordered.merchants &&
            nextProps.ordered.delivery && [
              ...nextProps.ordered.merchants,
              ...nextProps.ordered.delivery,
            ]) ||
          [],
      };

      switch (prevState.filterBy.dbName) {
        case 'users':
          let filter;
          switch (prevState.filterBy.type) {
            case 'text':
              filter = new FilterByText(modifiedState.users);
              return (modifiedState = {
                ...modifiedState,
                users: filter.filter(prevState),
              });
            case 'number':
              filter = new FilterByNumber(modifiedState.users);
              return (modifiedState = {
                ...modifiedState,
                users: filter.filter(prevState),
              });

            default:
              filter = new FilterBySelect(modifiedState.users);
              return (modifiedState = {
                ...modifiedState,
                users: filter.filter(prevState),
              });
          }

        case 'vendors':
          switch (prevState.filterBy.type) {
            case 'text':
              filter = new FilterByText(modifiedState.vendors);
              return (modifiedState = {
                ...modifiedState,
                vendors: filter.filter(prevState),
              });

            default:
              filter = new FilterBySelect(modifiedState.vendors);
              return (modifiedState = {
                ...modifiedState,
                vendors: filter.filter(prevState),
              });
          }

        default:
        // inbox
      }
    }

    return null;
  }

  //   Events
  selectRecipient(to) {
    if (to.name == 'All') {
      this.setState({
        ...this.state,
        recipients: ['users'],
        sendTo: ['All'],
      });
    } else if (this.state.recipients.includes(to.value)) {
      this.setState({
        ...this.state,
        recipients: this.state.recipients.filter((r) => r !== to.value),
        sendTo: this.state.sendTo.filter((r) => r !== to.name),
      });
    } else {
      const recipients = this.state.recipients.filter((r) => r !== 'users');
      this.setState({
        ...this.state,
        recipients: [...recipients, to.value],
        sendTo: [...this.state.sendTo.filter((r) => r !== 'All'), to.name],
      });
    }
  }

  // assign or remove vendors to admin (SUPPORT)
  assignOrRemoveVendor(e, vendor, supportAdmin) {
    this.$f7.preloader.show();

    let assignedVendors = supportAdmin.assignedVendors
      ? [...supportAdmin.assignedVendors]
      : [];

    let vendorType = vendor.businessProfile.hasOwnProperty('ownsDelivery')
      ? 'Merchant'
      : 'Delivery';

    const isChecked = e.target.checked;

    // if checked, assign vendor to agent
    if (isChecked) {
      assignedVendors.push({
        id: vendor.id,
        type: vendorType,
      });
    } else {
      // un-assign
      assignedVendors = assignedVendors.filter((v) => {
        if (v.id === vendor.id && v.type === vendorType) {
          return false;
        } else {
          return true;
        }
      });
    }

    // save agains support admin object in DB
    this.props.firestore
      .collection('users')
      .doc(supportAdmin.id)
      .update({ assignedVendors })
      .then(() => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: isChecked
            ? `${vendor.businessProfile.name} has been assigned to ${supportAdmin.fullName}`
            : `${vendor.businessProfile.name} has been unassigned from ${supportAdmin.fullName}`,
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  actionAgainstUser(type, id, role) {
    this.$f7.preloader.show();
    let action = type === 'suspend' ? 'Suspended' : 'Approved';
    let supportAdmin = role === 'Support' ? true : false;

    let update = {
      accountStatus: action,
    };

    if (supportAdmin && action === 'Suspended') {
      update.assignedVendors = [];
    }

    this.props.firestore
      .collection('users')
      .doc(id)
      .update(update)
      .then(() => this.$f7.preloader.hide())
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  // Change user role
  changeUserRole(userId, role, name) {
    this.$f7.preloader.show();

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        // send OTP to Easychaw's email
        sendEasychawOneTimePassword(
          {
            token: idToken,
            uid: this.props.auth.uid,
            actions: 'Role',
            details: { name, role },
          },
          (error, sent) => {
            if (error || !sent) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }

            // open a dialog to confirm OTP
            this.$f7.preloader.hide();
            this.$f7.dialog
              .create({
                title: 'OTP CODE',
                cssClass: 'otp-code-modal',
                text:
                  "Confirm this action by filling in the OTP code sent to Easychaw's email address",
                content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                buttons: [
                  // button to resend otp
                  {
                    text: 'Resend Code',
                    color: 'gray',
                    cssClass: 'otp-resend',

                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      sendEasychawOneTimePassword(
                        {
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, sent) => {
                          if (error || !sent) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: 'bottom',
                              horizontalPosition: 'center',
                              closeButton: true,
                              cssClass: 'custom-toast',
                              closeTimeout: 4000,
                            });
                          }

                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: 'OTP code sent',
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }
                      );
                    },
                  },
                  // button to cancel
                  {
                    text: 'x',
                    color: 'white',
                    cssClass: 'otp-close',
                    onClick: (dialog, e) => {
                      this.$f7.preloader.hide();
                    },
                  },
                  // button to continue
                  {
                    text: 'Continue',
                    bold: true,
                    cssClass: 'otp-continue',
                    keyCodes: [13],
                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      // password
                      const password = dialog.$el.find('.dialog-input').val();

                      // Verify otp
                      verifyEasychawOneTimePassword(
                        {
                          password,
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, success) => {
                          if (error || !success) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: 'bottom',
                              horizontalPosition: 'center',
                              closeButton: true,
                              cssClass: 'custom-toast',
                              closeTimeout: 4000,
                            });
                          }

                          // close dialog
                          dialog.close();
                          this.props.firestore
                            .collection('users')
                            .doc(userId)
                            .update({ role })
                            .then(() => {
                              this.$f7.preloader.hide();
                              toast(this.$f7.toast, {
                                text: `${name} now has ${role} user previlages`,
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            })
                            .catch((error) => {
                              this.$f7.preloader.hide();
                              toast(this.$f7.toast, {
                                text: handleErrors(error),
                                position: 'bottom',
                                horizontalPosition: 'center',
                                closeButton: true,
                                cssClass: 'custom-toast',
                                closeTimeout: 4000,
                              });
                            });
                        }
                      );
                    },
                  },
                ],
              })
              .open();
          }
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: error,
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  // Assign support staff to vendor
  supportVendor() {
    this.$f7.$('#support-vendor').show();
  }

  // Send notification
  sendNotification() {
    this.$f7.preloader.show();

    // validate input
    if (
      this.state.notificationTitle === '' ||
      this.state.notificationBody === ''
    ) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'All fields are required',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // validate input
    if (this.state.recipients.length === 0) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Please select a recipient',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    let type =
      this.state.recipients.length === 1
        ? this.state.recipients[0]
        : this.state.recipients;

    const notification = {
      title: this.state.notificationTitle,
      body: this.state.notificationBody,
      timestamp: Date.now(),
      reads: [],
      type,
      to: 'All',
    };

    this.props.firestore
      .collection('notification')
      .add(notification)
      .then(() => {
        this.setState({
          ...this.state,
          notificationTitle: '',
          notificationBody: '',
          recipients: ['users'],
          sendTo: ['All'],
          popupOpened: false,
        });
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: 'Notification sent.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { data, ordered },
}) => ({
  auth,
  profile,
  data,
  ordered,
});

const enhance = compose(
  withFirestore,
  firestoreConnect([
    new Collections('users'),
    new Collections('merchants'),
    new Collections('delivery'),
  ]),
  connect(mapStateToProps)
);

export default enhance(AdminUsers);
